define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/action",
	"csi/action/FormData",
	"csi/table/New",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"BusinessPlanning/BusinessPlanForm"
], function(array,declare,action,FormData,New,ActionControllerMixin,xml,BusinessPlanForm) {

	return declare([New, ActionControllerMixin], {
		// FormData: form data storing selected markets
		_fdMarkets: null,

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			var indexOfPage = wizard.getIndexOfPage(nextPage);
			var category = this._getCategory();
			var	bRefresh = false;
			var	dfd, fd;

			if (indexOfPage == 0) {
				// moving to BusinessPlan create form
				fd = this.m_formData;
			} else if (indexOfPage == 1) {
				// moving to table view of selected BusinessPlan's BusinessCategory
				fd = this._fdMarkets = this._fdMarkets || new FormData(this);
				fd.m_fAggregateSelected = Boolean;
				
				// if form data node has changed, then reset selections and refresh view
				if (fd.getNode() != category) {
					// if finishing, then reset markets so all will be included
					if (bFinish) {
						this._fdMarkets = null;
						return null;
					}

					fd.setNode(category);
					fd.resetAggregations();
					fd.resetSelections();
					bRefresh = true;
				}
			}

			return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
		},

		_getCategory: function() {
			// summary: get selected BusinessCategory
			var	fd = this.m_formData;
			return fd.getCache().getNode(fd.getFieldValue("Category", true), true);
		},

		toWriter: function() {
			// summary: publish category and markets specially from other fields
			var	category = this._getCategory();
			var	markets = category.Markets;
			
			if (this._fdMarkets) {
				markets = array.map(this._fdMarkets.getSelectedNodes(true), xml.nodeGetURL);
			}
			
        	this.inherited(arguments);

            this.m_writer.callMethod("BusinessPlanning", "BusinessPlanSetCategory")
            	.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.m_urlNode)
            	.addParameter(xml.PROP_URL, xml.ATTR_REF, category.$URL)
                .addParameter(xml.PROP_AGGREGATE_ADDS, xml.ATTR_REFLIST, markets);
		}
	});
});